"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = require("../../stores/global");
var setTurnedOff_1 = require("./setTurnedOff");
var checkRequiredPlayState_1 = __importDefault(require("../playback/checkRequiredPlayState"));
function setTurnedOn() {
    var action = function (dispatch, getState) {
        dispatch((0, global_1.setTurnedOnState)(true));
        var notification = (0, setTurnedOff_1.selectTurnedOffNotification)(getState());
        notification && dispatch((0, setTurnedOff_1.removeTurnOffNotification)(notification.id));
        dispatch((0, checkRequiredPlayState_1.default)());
    };
    action.type = setTurnedOn.type;
    return action;
}
setTurnedOn.type = "setTurnedOn";
exports.default = setTurnedOn;
//# sourceMappingURL=setTurnedOn.js.map